import React, { Fragment, useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { useDispatch, useSelector } from 'react-redux';

import { editarBreadcrumb } from '../../../actions/breadcrumb';
import { buscarPadelsConfiguracion } from '../../../actions/configuracion';

import NuevaPadel from './NuevaPadel';
import EditarPadel from './EditarPadel';
import EliminarPadel from './EliminarPadel';

const Padels = () => {

    let rutasBread = [
        {
            activo: true,
            nombre: 'Cancha de pádel',
            path: '/configuracion/padel'
        }
    ];

    const dispatch =  useDispatch();

    const { listado } = useSelector(state => state.configuracion.padels);

    const [padels, setPadels] = useState([]);

    const [padelAgregar, setPadelAgregar] = useState(null);
    const [padelEditar, setPadelEditar] = useState(null);
    const [padelEliminar, setPadelEliminar] = useState(null);

    const paginationOptions = { rowsPerPageText: 'Filas por página', rangeSeparatorText: 'de' };

    const columns = [
        {
            name: 'Nombre',
            sortable: true, 
            selector: row => row.nombre,
        },
        {
            name: 'Intervalo de reserva',
            sortable: true, 
            selector: row => intervaloToText(row.intervalo_reserva)
        },
        {
            name: 'Lunes',
            sortable: true, 
            cell: item => `${item.horarios[1] ? horariosToText(item.horarios[1]) : '-'}`
        },
        {
            name: 'Martes',
            sortable: true, 
            cell: item => `${item.horarios[2] ? horariosToText(item.horarios[2]) : '-'}`
        },
        {
            name: 'Miercoles',
            sortable: true, 
            cell: item => `${item.horarios[3] ? horariosToText(item.horarios[3]) : '-'}`
        },
        {
            name: 'Jueves',
            sortable: true, 
            cell: item => `${item.horarios[4] ? horariosToText(item.horarios[4]) : '-'}`
        },
        {
            name: 'Viernes',
            sortable: true, 
            cell: item => `${item.horarios[5] ? horariosToText(item.horarios[5]) : '-'}`
        },
        {
            name: 'Sabado',
            sortable: true, 
            cell: item => `${item.horarios[6] ? horariosToText(item.horarios[6]) : '-'}`
        },
        {
            name: 'Domingo',
            sortable: true, 
            cell: item => `${item.horarios[0] ? horariosToText(item.horarios[0]) : '-'}`
        },
        {
            name: '',
            cell: row => {
                if(row._id){
                    return(
                        <div className="text-right w-100">
                            <button type="button" className="btn btn-sm btn-link px-2 float-end" onClick={() => handleEliminarPadel(row)}><i className="fas fa-trash text-danger"></i></button>
                            <button type="button" className="btn btn-sm btn-link px-2 float-end" onClick={() => handleEditarPadel(row)}><i className="fas fa-edit text-warning"></i></button>
                        </div>
                    )
                }else{
                    return(<></>)
                }
            }
        }
    ];

    /* Crear cancha */
    const handleAgregarPadel = (padel) => {
        setPadelEditar(null);
        setPadelEliminar(null);

        setPadelAgregar(padel);        
    }

    /* Editar cancha */
    const handleEditarPadel = (padel) => {
        setPadelAgregar(null);
        setPadelEliminar(null);

        setPadelEditar(padel);
    }

    /* Eliminar cancha */
    const handleEliminarPadel = (padel) => {
        setPadelAgregar(null);
        setPadelEditar(null);

        setPadelEliminar(padel);
    }

    /* Funciones generales */
    const horariosToText = (horarios) => {
        let horarios_formateados = [];

        for (let i = 0; i < horarios.length; i++) {
            horarios_formateados.push(horarios[i].hora_inicio + ' - ' + horarios[i].hora_fin);
        }

        return horarios_formateados.join(', ');
    }

    const intervaloToText = (intervalo) => {
        let intervalo_texto = '';

        switch(intervalo){
            case 15:
                intervalo_texto = '15 minutos';
                break;

            case 30:
                intervalo_texto = '30 minutos';
                break;

            case 60:
                intervalo_texto = '1 hora';
                break;

            case 90:
                intervalo_texto = '1 hora y media';
                break;

            case 120:
                intervalo_texto = '2 horas';
                break;

            default:
                intervalo_texto = 'Sin definir';
                break;
        }

        return intervalo_texto;
    }

    useEffect(() => {
        dispatch(buscarPadelsConfiguracion(true));
    }, []);

    useEffect(() => {
        setPadels(listado);
    }, [listado]);

    useEffect(() => {
        dispatch(editarBreadcrumb(rutasBread));
    }, [rutasBread]);

    return (
        <Fragment>

            <NuevaPadel padel={padelAgregar} reestablecerPadel={handleAgregarPadel} />
            <EditarPadel padel={padelEditar} reestablecerPadel={handleEditarPadel} />
            <EliminarPadel padel={padelEliminar} reestablecerPadel={handleEliminarPadel} />

            <div className="row">
                <div className="col-md-10 offset-md-1 pb-4">
                    <h3 className="mb-3 mt-5">Cancha de pádel</h3>

                    <div className="d-flex justify-content-end">
                        <button type="button" className="btn btn-primary" onClick={() => handleAgregarPadel({ })}>Agregar cancha</button>
                    </div>

                    <div className="mt-2">
                        <DataTable 
                            columns={columns}
                            data={padels}
                            pagination
                            paginationPerPage={20}
                            paginationRowsPerPageOptions={[5, 10, 20, 50]}
                            paginationComponentOptions={paginationOptions}
                            highlightOnHover={true}
                        />
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default Padels;